import React from 'react';
import { InputNumber } from 'antd';

export const FormInputNumber = ({ value = '', onChange, getEvent, name, type, suffix, prefix, ...rest }) => {
	const handleChange = (inputVal) => {
		if (onChange) {
			onChange(inputVal);
		}

		if (getEvent) {
			const target = { name, value: inputVal };
			getEvent({ target });
		}
	};
	if (suffix || prefix) {
		return (
			<span className="ant-input-group-wrapper">
				<span className="ant-input-wrapper ant-input-group">
					{prefix && <span className="ant-input-group-addon">{prefix}</span>}
					<InputNumber
						name={name || `input_name`}
						value={value >= 0 ? value : ''}
						onChange={handleChange}
						autoComplete="Off"
						readOnly={!!rest.readOnly}
						disabled={!!rest.disabled}
						placeholder={rest.placeholder || ''}
						id={rest.id || `_uid${Math.random() * 10}`}
						className={rest.input_class ?? `form-control w-100 hide-number-arrow`}
						formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
						parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
						{...rest}
					/>
					{suffix && <span className="ant-input-group-addon">{suffix}</span>}
				</span>
			</span>
		);
	}

	return (
		<InputNumber
			name={name || `input_name`}
			value={value >= 0 ? value : ''}
			onChange={handleChange}
			autoComplete="off"
			readOnly={!!rest.readOnly}
			disabled={!!rest.disabled}
			placeholder={rest.placeholder || ''}
			id={rest.id || `_uid${Math.random() * 10}`}
			className={rest.input_class ?? `form-control w-100 hide-number-arrow`}
			formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
			parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
			{...rest}
		/>
	);
};
